import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (es: string, en: string) => string;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'es',
  setLang: () => {},
  t: es => es
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const t = (es: string, en: string) => lang === 'es' ? es : en;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-189">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}